const jQ = jQuery.noConflict();

const searchIcon = jQ('.icon-search');
const searchInput = jQ('.search-text');
const submitSearch = jQ('.submit-search');
const tabletChecker = window.matchMedia('screen and (max-width: 1024px)');
const mobileChecker = window.matchMedia('screen and (max-width: 768px)');
const headerInput = jQ('.main-header__search').find(searchInput);
const logo = jQ('.main-header__logo');
const searchTriggerIcon = jQ('.search-trigger').find('.icon-search');

function expandInput() {
    const prev = jQ(this).prev(searchInput);
    const sub = jQ(this).next(submitSearch);

    if ((prev.hasClass('expanded')) && (prev.val().length > 0)) {
        sub.trigger('click');
    } else {
        prev.toggleClass('expanded');
    }
}

function tabletOverlay() {
    if (tabletChecker.matches) {
        if (headerInput.hasClass('expanded') || headerInput.hasClass('expanded-menu')) {
            logo.css({
                opacity: 0,
                'z-index': 0,
            });
        } else {
            logo.css({
                opacity: 1,
                'z-index': 10,
            });
        }
    }
}
function blockSubmit(e) {
    if (!jQ(this).parent().find(searchInput).val()) {
        e.preventDefault();
    }
}

function clickOutside() {
    if (searchInput.hasClass('expanded')) {
        searchInput.removeClass('expanded');
        if (jQ('.mobile-form').length > 0) {
            jQ('.mobile-form').removeClass('visible-form');
        }
    }
}

function searchBlogPage(event) {
    if (event.keyCode === 8) {
        if (mobileChecker.matches) {
            if (jQ('.mobile-form .blog-page-search .search-text').val().length == 0) {
                jQ('.mobile-form .blog-page-search .icon-search').click();
                setTimeout(() => {
                    jQ('.mobile-form').removeClass('visible-form');
                }, 500);
            }
        } else if (jQ('.blog-page-search .search-text').val().length == 0) {
            jQ('.blog-page-search .icon-search').click();
        }
    }
}

function blogSearch() {
    jQ('.mobile-form').find(searchIcon).click();
    if (jQ('.mobile-form').hasClass('visible-form')) {
        setTimeout(() => {
            jQ('.mobile-form').removeClass('visible-form');
        }, 500);
    } else {
        jQ('.mobile-form').addClass('visible-form');
    }
}

function initSearch() {
    if (searchIcon.length > 0) {
        searchIcon.on('click', expandInput);
        searchIcon.on('click', tabletOverlay);
        tabletOverlay();
        searchTriggerIcon.on('click', blogSearch);
    }
    jQ(document).on('keyup', searchBlogPage);
    submitSearch.on('click', blockSubmit);
    jQ(window).on('click', (e) => {
        if (searchIcon.length > 0) {
            if ((!jQ(e.target).is(searchIcon)) && (!jQ(e.target).is(searchInput))) {
                clickOutside();
            }
        }
    });
}


export default initSearch;
